<template>
  <div class="download-container">
    <header class="download-hd">
      <div
        class="download-hd-wrapper"
        v-scroll-animate="{
          animation: 'fadeInDown',
        }"
      >
        <h4 class="download-hd-subTitle">Download Center</h4>
        <h2 class="download-hd-title">Obtain Software and Product Manual</h2>
        <h4 class="download-hd-subTitle">
          Explore knowledge, practice, and innovate with trusted partners.
        </h4>
        <h4 class="download-hd-subTitle">Technical Support: 4000-025-828</h4>
      </div>
    </header>

    <AnchorTabs ref="downloadAnchorTabsRef" :tabList="tabList" />

    <div class="cardBox">
      <!-- 软件产品 -->
      <div id="software" class="title">Download Design Software!</div>
      <template v-if="softwareList.length > 0">
        <div class="cardArea">
          <div
            v-for="(item, index) in softwareList"
            :key="index"
            class="softwareCard"
            v-scroll-animate="{
              animation: 'fadeInUp',
              delay: index * 200,
            }"
          >
            <img
              v-if="item.picUrl"
              :src="item.picUrl"
              alt="icon"
              class="icon"
            />
            <img
              v-else
              src="@/assets/images/fallbackImg.png"
              alt="FallbackImg"
              class="icon"
            />
            <div class="title">{{ item.title }}</div>

            <div class="summary">{{ item.summary }}</div>

            <div
              style="
                width: 76px;
                height: 21px;
                margin: 20px auto 0;
                display: flex;
                gap: 16px;
                display: none;
              "
            >
              <img
                alt="system"
                src="@/views/web/home/imgs/icon1.svg"
                width="22px"
              />
              <div style="width: 1px; height: 21px; background: #d8d8d8"></div>
              <img
                alt="windows"
                src="@/views/web/home/imgs/icon2.svg"
                width="21px"
              />
            </div>

            <DownLoad
              class="downloadBtn"
              :id="item.id"
              :type="'1'"
              :btnLabel="item.downloadButtonName"
              :fileUrl="item.fileUrl"
              :fileName="item.fileTitle"
            />
          </div>
        </div>
      </template>
      <template v-else>
        <EmptyPage :name="'No data available at the moment!'" />
      </template>
      <!-- 用户手册 -->
      <div id="manual" class="title">Download Product Manual！</div>
      <template v-if="manualList.length > 0">
        <div class="cardArea">
          <div
            v-for="(item, index) in manualList"
            :key="index"
            class="manualCard"
            v-scroll-animate="{
              animation: 'fadeInUp',
              delay: index * 200,
            }"
          >
            <img
              v-if="item.picUrl"
              :src="item.picUrl"
              class="icon"
              alt="manual"
            />
            <img
              v-else
              src="@/assets/images/fallbackImg.png"
              alt="FallbackImg"
              class="icon"
            />
            <div class="title">{{ item.title }}</div>

            <DownLoad
              class="downloadBtn"
              :id="item.id"
              :type="'2'"
              :btnLabel="item.downloadButtonName"
              :fileUrl="item.fileUrl"
              :fileName="item.fileTitle"
            />
          </div>
        </div>
      </template>
      <template v-else>
        <EmptyPage :name="'No data available at the moment!'" />
      </template>
    </div>

    <ProductGet
      title="DELAUNEY"
      subTitle="Serving over 1000 corporate clients and 20000+designer users!"
      :bgImage="require('@/views/web/home/imgs/downloadBottom.png')"
      :downLoadBtn="{
        show: false,
      }"
    />
  </div>
</template>

<script>
import DownLoad from "@/components/DownLoad";
import AnchorTabs from "@/components/AnchorTabs.vue";
import ProductGet from "@/components/ProductGet.vue";
import R3D from "@/views/web/home/imgs/R3D.png";
import AIRoad from "@/views/web/home/imgs/AIRoad.png";
import EICAD from "@/views/web/home/imgs/EICAD.png";
import VRRoad from "@/views/web/home/imgs/VRRoad.png";
import downLoadBtn from "@/views/web/home/imgs/downloadBtn.png";
import ChineseManual from "@/views/web/home/imgs/ChineseManual.png";
import EnglishManual from "@/views/web/home/imgs/EnglishManual.png";

import EmptyPage from "@/components/EmptyPage.vue";

import { softwareAllApi } from "@/api/website";
export default {
  data() {
    return {
      softwareList: [
        // 默认数据
        // {
        //   id: 1,
        //   title: "Report3D",
        //   downloadButtonName: "Download",
        //   picUrl: R3D,
        //   summary:
        //     "A 3D solution reporting tool, easily build 3D scenes And report solutions.",
        //   fileUrl: "",
        // },
        // {
        //   id: 2,
        //   title: "AIRoad",
        //   downloadButtonName: "Download",
        //   picUrl: AIRoad,
        //   summary: "Road Engineering Schematic Design System.",
        //   fileUrl: "",
        // },
        // {
        //   id: 3,
        //   title: "EICAD 5.0 For AutoCAD",
        //   downloadButtonName: "Download",
        //   picUrl: EICAD,
        //   summary: "Integrated Interactive Road And Interchange Design System.",
        //   fileUrl: "",
        // },
        // {
        //   id: 4,
        //   title: "EICAD 5.0 For ZWCAD",
        //   downloadButtonName: "Download",
        //   picUrl: EICAD,
        //   summary: "Integrated Interactive Road And Interchange Design System.",
        //   fileUrl: "",
        // },
        // {
        //   id: 5,
        //   title: "VRRoad",
        //   downloadButtonName: "Download",
        //   picUrl: VRRoad,
        //   summary: "Road Driving Simulation And Safety Evaluation System.",
        //   fileUrl: "",
        // },
      ],
      manualList: [
        // 默认数据
        // {
        //   id: 1,
        //   title: "江苏狄诺尼手册",
        //   downloadButtonName: "Download",
        //   picUrl: ChineseManual,
        //   fileUrl: "",
        // },
        // {
        //   id: 2,
        //   title: "Delauney Manual",
        //   downloadButtonName: "Download",
        //   picUrl: EnglishManual,
        //   fileUrl: "",
        // },
      ],
      tabList: [
        {
          name: "Software",
          value: "software",
        },
        {
          name: "Product Manual",
          value: "manual",
        },
      ],
      downLoadBtnPath: downLoadBtn,
      type: "sofeware",
    };
  },
  components: {
    ProductGet,
    AnchorTabs,
    DownLoad,
    EmptyPage,
  },
  async created() {
    await this.getSoftwareList();
    this.type = this.$route.query.type;
    if (this.type) {
      this.$nextTick(() => {
        this.$refs.downloadAnchorTabsRef.handleTabClick(this.type);
      });
    }
  },

  methods: {
    async getSoftwareList() {
      await softwareAllApi().then((res) => {
        console.log(res.data);
        if (res.code == 200 && res.success) {
          // 查找出已启用且生效的数据
          let nowTimeString = this.$uniFun.getNowTime();
          let temp1 = res.data.softwareList.filter(
            (item) => nowTimeString > item.effectiveTime
          );
          let temp2 = res.data.softwareHelpList.filter(
            (item) => nowTimeString > item.effectiveTime
          );

          this.softwareList = temp1.map((item) => {
            return {
              id: item.id,
              title: item.name,
              downloadButtonName: item.downloadButtonName,
              picUrl:
                item.coverUrlIdList.length > 0
                  ? item.coverUrlIdList[0].path
                  : "",
              summary: item.description,
              fileUrl:
                item.pathUrlIdList.length > 0 ? item.pathUrlIdList[0].path : "",
              fileTitle:
                item.pathUrlIdList.length > 0
                  ? item.pathUrlIdList[0].fileTitle
                  : "",
            };
          });
          this.manualList = temp2.map((item) => {
            return {
              id: item.id,
              title: item.name,
              downloadButtonName: item.downloadButtonName,
              picUrl:
                item.coverUrlIdList.length > 0
                  ? item.coverUrlIdList[0].path
                  : "",
              fileUrl:
                item.pathHelpUrlIdList.length > 0
                  ? item.pathHelpUrlIdList[0].path
                  : "",
              fileTitle:
                item.pathHelpUrlIdList.length > 0
                  ? item.pathHelpUrlIdList[0].fileTitle
                  : "",
            };
          });
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/assets/styles/common.scss";
.download-container {
  width: 100%;
  background: #fff;
  //padding-bottom: 100px;
}

.download-hd {
  width: 100%;
  height: 320px;
  background: url("~@/views/web/home/imgs/downloadTop.png") no-repeat center;
  background-size: cover;
  .download-hd-wrapper {
    width: 1049px;
    padding-top: 70px;
    margin: 0 auto;
  }
  .download-hd-title {
    margin-bottom: 20px;
    font-weight: bold;
    font-size: 28px;
    color: #ffffff;
    line-height: 28px;
    font-style: normal;
  }
  .download-hd-subTitle {
    margin-bottom: 20px;
    font-weight: 400;
    font-size: 18px;
    color: #ffffff;
    line-height: 27px;
    font-style: normal;
  }
}

.cardBox {
  display: flex;
  flex-direction: column;
  gap: 40px;
  width: 1048px;
  margin: 0 auto;
  padding: 40px 0;

  .title {
    height: 24px;
    font-weight: bold;
    font-size: 24px;
    color: #1d1d1f;
    line-height: 24px;
    text-align: left;
    font-style: normal;
  }
  .cardArea {
    width: 100%;
    height: auto;
    flex-wrap: wrap; /* 允许换行 */
    align-content: flex-start; /* 控制多行内容的对齐方式 */
    display: flex;
    gap: 29px;
  }
}

.softwareCard {
  width: 240px;
  height: 280px;
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
  text-align: center;
  padding: 24px 20px;

  .icon {
    width: 48px;
    height: 48px;
  }

  .title {
    width: fit-content;
    height: 16px;
    font-weight: bold;
    font-size: 16px;
    color: #1d1d1f;
    line-height: 16px;
    text-align: center;
    font-style: normal;
    margin: 18px auto 0;
  }

  .summary {
    @extend .text-truncate-multiline;
    --line-clamp: 3;
    height: 48px;
    margin-top: 8px;
    width: 200px;
    font-weight: 400;
    font-size: 14px;
    color: #1d1d1f;
    line-height: 16px;
    text-align: center;
    font-style: normal;
  }

  .downloadBtn {
    margin: 33px auto 0;
  }

  cursor: pointer;
  transition: all 0.3s ease-in-out;
  &:hover {
    transform: translateY(-5px); // Slight lift effect on hover
  }
}

.manualCard {
  width: 240px;
  height: 250px;
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
  padding-top: 32px;
  text-align: center;

  .icon {
    width: 84px;
    height: 114px;
  }

  .title {
    width: fit-content;
    height: 16px;
    font-weight: bold;
    font-size: 16px;
    color: #1d1d1f;
    line-height: 16px;
    text-align: center;
    font-style: normal;
    margin: 12px auto 0;
  }
  .downloadBtn {
    width: 100px;
    margin: 28px auto 0;
  }

  cursor: pointer;
  transition: all 0.3s ease-in-out;
  &:hover {
    transform: translateY(-5px); // Slight lift effect on hover
  }
}
</style>
